import { useAppSelector } from '@/store/hooks'
import type { RootState } from '@/store'
import { instructionsApi } from '@/features/instructions/instructionsApi'
import { articleModerationApi } from '@/features/moderation/articleModerationApi'

type Sub = { status: string; startedTimeStamp?: number }

/** Когда УШЁЛ запрос, чей ответ сейчас лежит в кеше. Летящий или упавший — ответ старше,
 *  его начало неизвестно: `undefined`. */
const readAt = (sub: Sub): number | undefined =>
  sub.status === 'fulfilled' ? sub.startedTimeStamp : undefined

const selectSeedReadAt = (state: RootState, slug: string, id: number): number | undefined => {
  const article = readAt(instructionsApi.endpoints.getInstruction.select(slug)(state))
  const draft = readAt(articleModerationApi.endpoints.getArticleModeration.select(id)(state))
  return article === undefined || draft === undefined ? undefined : Math.min(article, draft)
}

/**
 * Засев существующей статьи собран из ДВУХ ответов — статьи и модерации. Возвращает момент,
 * не раньше которого ушли оба (`startedTimeStamp`, а не время ответа: опрос, ушедший до
 * записи, мог вернуться и после неё). По нему `useArticleForm` узнаёт ИТОГОВЫЙ засев после
 * сохранения, даже если тот совпал с прежним по значениям.
 */
export const useSeedReadAt = (slug: string | undefined, id: number | undefined) =>
  useAppSelector((state) =>
    slug && id !== undefined ? selectSeedReadAt(state, slug, id) : undefined,
  )
